(function () {
  'use strict';
  var root = document.querySelector('.customer-voice-blog');
  if (!root) return;
  var buttons = root.querySelectorAll('[data-cv-filter]');
  var cards = root.querySelectorAll('.customer-voice-card');
  var status = root.querySelector('[data-cv-status]');
  if (!buttons.length || !cards.length) return;

  function apply(key) {
    var shown = 0;
    cards.forEach(function (card) {
      var visible = key === 'all' || card.getAttribute('data-cv-theme') === key;
      card.hidden = !visible;
      if (visible) shown += 1;
    });
    buttons.forEach(function (btn) {
      btn.setAttribute('aria-pressed', btn.getAttribute('data-cv-filter') === key ? 'true' : 'false');
    });
    if (status) status.textContent = shown + '件を表示中';
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      apply(btn.getAttribute('data-cv-filter'));
    });
  });
})();
